import React, { useEffect } from 'react';
import { SalesPage } from './components/SalesPage';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <SalesPage data-id="element-0" />;
}